import {signal, WritableSignal} from '@angular/core';
import {IDocumentVerification, IDocumentVerificationValueSource, IMetaTagValue, IValidation, ValidationDocCountryCode, ValidationDocType, ValidationType} from '@core/api/data-access';
import {TextFieldType} from '@regulaforensics/document-reader-webclient';
import {ValueToValidateStruct} from '@validations/document-reader/data-access';

import {ValidationModel} from '../validation.abstract.model';

// DocumentVerification
export class DocumentVerificationValidationModel extends ValidationModel implements IDocumentVerification {
	originalInstance: IValidation;
	public ordinal = NaN;
	public readonly type = ValidationType.DocumentVerification;

	public documentType: ValidationDocType[] | null = []; // null or empty array - means any document type accepted
	public countryCodes: ValidationDocCountryCode = ValidationDocCountryCode.Any; // Any	- means any country code accepted

	public valueToCompareSource: IDocumentVerificationValueSource | null = null;

	public getValueToValidateStruct(metaTags: IMetaTagValue[]): ValueToValidateStruct {
		if (this.valueToCompareSource) {
			if (this.valueToCompareSource?.staticValue) return {documentFieldType: TextFieldType.PERSONAL_NUMBER, value: this.valueToCompareSource?.staticValue};
			else if (this.valueToCompareSource?.metaTag)
				return {
					documentFieldType: TextFieldType.PERSONAL_NUMBER,
					value: metaTags.find(tag => tag.metaTag === this.valueToCompareSource?.metaTag)?.value,
				};
		}
		return null;
	}

	constructor(initWith: IDocumentVerificationValueSource = null) {
		super();
		this.valueToCompareSource = initWith;
	}

	override asDocumentVerification(): DocumentVerificationValidationModel {
		return this;
	}

	private forceValid: WritableSignal<boolean> = signal<boolean>(false);

	public setValidity(validity: boolean): void {
		this.forceValid.set(validity);
	}

	isValid(): boolean {
		if (this.forceValid()) return true;
		if (isNaN(this.ordinal)) return false;
		if (this.valueToCompareSource) {
			if (this.valueToCompareSource?.staticValue) return Boolean(this.valueToCompareSource?.staticValue);
			else if (this.valueToCompareSource?.metaTag) return Boolean(this.valueToCompareSource?.metaTag);
			else return false;
		}
		return true;
	}

	toJSON(): IDocumentVerification {
		return {
			ordinal: this.ordinal,
			type: ValidationType.DocumentVerification,
			documentType: this.documentType,
			countryCodes: this.countryCodes,
			valueToCompareSource: this.valueToCompareSource,
		};
	}

	toObject(): IDocumentVerification {
		return this.toJSON();
	}
}
